var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIconn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.5,
    height: 60.5,
    viewBox: "0 0 60.5 60.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success_icon",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M18,34.218l8.145,8.145L46.509,22",
    transform: "translate(0.273 0.345)",
    fill: "none",
    stroke: "#64d164",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(3 3)",
    fill: "none",
    stroke: "#64d164",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconn);
export default __webpack_public_path__ + "static/media/success_iconn.890a86c0782616711ea4957b5c2c1eb6.svg";
export { ForwardRef as ReactComponent };